import React from 'react';
import {IMyCoupons} from "../interfaces";
import {format} from "date-fns";
import {hasDST} from "../../../../domain/time-provider";

interface IMyCouponItemData {
    itemData: IMyCoupons
}
/**
 * MyCouponItemData
 */
const MyCouponItemData = (props:IMyCouponItemData) => {

    let status = 'status-default';
    const expDate =new Date(props.itemData.expires);

    if(props.itemData.statusID === 1){
        status = `text-red status-${props.itemData.statusID}`;
    }

    return (
        <li className={`mt-4 coupon ${status}`}>
            <div className="">Coupon code: <span className="status-color font-bold">{props.itemData.couponCode}</span></div>
            <div className="">Value: <b>{props.itemData.couponValue}</b></div>

            {
                format(expDate, "yyyy") !== "9999" &&
                <div className="coupon-expires">Expires  {format(expDate,"EEEE MMM d, yyyy h:mm a")} {hasDST(expDate) ? "EDT" : "EST"} </div>
            }

            { format(expDate, "yyyy") === "9999" && <div className="coupon-expires">Limited time only</div> }

            <div className="coupon-status"><span className="text-red">{props.itemData.statusID === 1 ? "You have already redeemed this coupon." : ""}</span></div>
        </li>
    )
};

export default  MyCouponItemData;